// Written in this round about way for babel-transform-imports
import Router from 'react-router/es/Router';

export default Router;


//////////////////
// WEBPACK FOOTER
// c:/jenkins/workspace/plesk-17.8/~/react-router-dom/es/Router.js
// module id = 13
// module chunks = 1 2 3 4 5